import StickyHeader from '@/js/components/sticky_header/stickyHeader';

const header = document.getElementById('site-nav');

if (header) {
  // eslint-disable-next-line no-new
  new StickyHeader(header);
}
